import React from 'react'
import box from '../features/Box/BoxSlice'
import BoxComponent from '../features/Box/components/Box'

const BoxPage = () => {
  return <BoxComponent />
}

BoxPage.getInitialProps = async ({ reduxStore }) => {
  await reduxStore.dispatch(box.fetchBox())

  return {
    metaTitle: 'Ramen box',
  }
}

BoxPage.defaultProps = {}

BoxPage.propTypes = {}

export default BoxPage
